import NotFound from "../pages/NotFound";
import { Navigate, useLocation } from "react-router-dom";

const BloggerRedirect = () => {
  const { pathname } = useLocation();

  // 1️⃣ YEAR or YEAR/MONTH (archive)
  if (/^\/\d{4}(\/\d{2})?$/.test(pathname)) {
    return <Navigate to="/blog" replace />;
  }

  // 2️⃣ BLOGGER STATIC PAGES
  if (pathname.startsWith("/p/")) {
    const cleanPage = pathname.replace("/p/", "").replace(".html", "");

    const staticPages: Record<string, string> = {
      "refund-policy": "/refund-policy",
      "privacy-policy": "/privacy-policy",
      "terms-and-conditions": "/terms",
      "shipping-policy": "/shipping-policy",
      "disclaimer": "/disclaimer",
      "about-us": "/about",
      "contact-us": "/contact",
    };

    if (staticPages[cleanPage]) {
      return <Navigate to={staticPages[cleanPage]} replace />;
    }

    // ❌ unknown /p/* → let router show 404
    return <NotFound />;
  }

  // 3️⃣ BLOG POSTS
  const postMatch = pathname.match(/^\/\d{4}\/\d{2}\/(.+)\.html$/);

  if (postMatch) {
    const cleanSlug = postMatch[1].replace(/-for$/, "");
    return <Navigate to={`/theme/${cleanSlug}`} replace />;
  }

  // 4️⃣ ❌ NOT BLOGGER URL → let router handle
  return <NotFound />;
};

export default BloggerRedirect;
